import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getLoginDto } from "@services/authenticationService";
import { environment } from "@environments/environment";
import { setAccessToken, setUserDto } from "@store/login/loginStore";
import { useLoginGateway } from "@hooks/store";

type AuthResult = { success: true } | { success: false; error: string };

type UseAuthSessionOptions = {
  /** Called after successful auth, before navigation (e.g. close modal) */
  onAuthenticated?: () => void;
};

export function useAuthSession(options?: UseAuthSessionOptions) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginGateway = useLoginGateway();

  const completeLogin = async (accessToken: string): Promise<AuthResult> => {
    localStorage.setItem("accessToken", accessToken);
    dispatch(setAccessToken(accessToken));

    const dtoResp = await getLoginDto(accessToken, loginGateway);
    const user = dtoResp?.[0];

    if (user) {
      localStorage.setItem("userDto", JSON.stringify(user));
      dispatch(setUserDto(user));
    }

    const roles = user?.roles || [];
    const evaluatorRoleId = environment.ROLE_IDS.EVALUATOR;
    const matchedRole = roles.find(
      (role: { roleId: string | number }) =>
        Number(role.roleId) === evaluatorRoleId
    );

    if (matchedRole) {
      options?.onAuthenticated?.();
      navigate("/dashboard");
      return { success: true };
    }

    return { success: false, error: "You are not a registered Evaluator" };
  };

  return { completeLogin };
}
